module.exports = __webpack_public_path__ + "img/button-home5.33dc7c83.jpeg";